import Layout from "../components/Layout";
import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../utils/commonUrl";
import EmpAssessmentCard from "../components/EmpAssessmentCard";
import { useSelector } from "react-redux";
import { Toast } from "primereact/toast";
import EmpInfoCard from "../components/EmpInfoCard";
import './SupervisorAssessmentPage.css';
import { Form } from "formik";
import Moment from "moment";

const EmployeeWiseActionPlan = () => {
    const primeToast = useRef(null)
    const { user } = useSelector(state => state['auth']);
    const [optionList, setOptionList] = useState([]);
    const [quater, setQuater] = useState([])
    const [assessmentIndicator, setAssessmentIndicator] = useState({ isLoading: false, list: [] })
    const [employees, setEmployees] = useState([])
    const [employeeAssessment, setEmployeeAssessment] = useState([])
    const [supervisorAssessment, setSupervisorAssessment] = useState([]);
    const [supervisorUpdateCount, setSupervisorUpdateCount] = useState([])
    const [isAssessmentLoading, setIsAssessmentLoading] = useState(false)
    const [tableData, setTableData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [taskList, setTaskList] = useState([]);

    const [activity, setActivity] = useState(['']);
    const [remarks, setRemarks] = useState(['']);
    const [fromdate, setFromDate] = useState(['']);
    const [toDate, setToDate] = useState(['']);
    const [registerId, setRegisterId] = useState(['']);

    useEffect(() => {
        loadAllEmployees();
        //getAssesstmentOpinionList();
    }, [])

    const loadAllEmployees = () => {
        axios.get(BASE_URL + "/api/employeetasklist/GetEmployeeListForSupervisor/" + user.registerID)
            .then(response => {
                setEmployees(response.data)
                console.log(response.data);
            })
            .catch(e => {
                console.log(e)
            })
    }

    const onEmployeeSelect = (e) => {
        const registerId = e.currentTarget.value;
        getActivityList(registerId, user.quarterID);
        getEmployeeAssessment(registerId)
        //getAssesstmentOpinionList();
        setRegisterId(registerId);
    }

    const getActivityList = async (id, quarterID) => {
        const data = {
            RegisterID: id,
            QuarterID: parseInt(quarterID)
        }
        setIsLoading(true);
        await axios.post(BASE_URL + "/api/employeetasklist/GetEmployeeActivity", JSON.stringify(data))
            .then(response => {
                setTableData(response.data);
                setIsLoading(false);
                //console.log(response.data);
            })
            .catch(function (error) {
                setTaskList(false);
                console.log(error);
            });
    }

    const getEmployeeAssessment = (id) => {
        setIsAssessmentLoading(true)
        axios.get(BASE_URL + "/api/employeetasklist/SupervisorSelectedEmployeeForTask/" + id)
            .then(response => {
                console.log(response.data);
                setIsAssessmentLoading(false)
                setEmployeeAssessment(response.data)
                //updateSupervisorAssessment(response.data)
            })
            .catch(e => {
                setIsAssessmentLoading(false)
                console.log(e)
            })
    }

    const onFormSave = (event) => {
        event.preventDefault();

        if (activity.length === 0) {
            primeToast.current.show({
                severity: 'error',
                summary: 'error',
                detail: 'Activity can not be empty.',
                life: 3000
            });
            return;
        }
        else if (fromdate.length === 0) {
            primeToast.current.show({
                severity: 'error',
                summary: 'error',
                detail: 'From date can not be empty.',
                life: 3000
            });
            return;
        }
        if (toDate.length === 0) {
            primeToast.current.show({
                severity: 'error',
                summary: 'error',
                detail: 'To date can not be empty.',
                life: 3000
            });
            return;
        }

        const data = {
            registerId: registerId,
            quarterId: user.quarterID,
            activity: activity,
            fromDate: fromdate,
            toDate: toDate,
            remarks: remarks,
            addedBy: user.registerID
        }
        const response = axios.post(BASE_URL + '/api/employeetasklist/SaveEmployeeActionPlan', data)
            .then((response) => {
                if (response.status === 200) {
                    getActivityList(registerId, user.quarterID);
                    clearControls();
                    primeToast.current.show({
                        severity: "success",
                        summary: "success",
                        detail: "Action Saved Successfully",
                        life: 3000,
                    });
                }
            });
    };

    const onDataDelete = async (sl, registerId) => {
        const unsetOpinion = tableData.filter((item) => Number(item.sl) === sl)
        console.log(unsetOpinion);

        const data = {
            SL: unsetOpinion[0].sl
        }
        console.log(JSON.stringify(data));
        await axios.post(BASE_URL + "/api/employeetasklist/DeleteEmployeeActivity/" + unsetOpinion[0].sl)
            .then((response) => {
                if (response.status === 200) {
                    primeToast.current.show({
                        severity: "success",
                        summary: "success",
                        detail: "Activity Deleted Successfully.",
                        life: 3000,
                    });
                    getActivityList(registerId, user.quarterID);
                    clearControls();
                }
            });
    };

    const clearControls = async () => {
        setActivity('');
        setRemarks('');
        setFromDate('');
        setToDate('');
    };

    function Table({ tableData }) {
        return (
            <table className="table" rows={10} paginator>
                <thead>
                    <tr>
                        <th>SL.</th>
                        <th>Activity</th>
                        <th>From Date</th>
                        <th>To Date</th>
                        <th>Remarks</th>
                        <th hidden={true}>ID</th>
                        <th className="text-center">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {tableData.map((data, index) => {
                        return (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{data.activity}</td>
                                <td>{Moment(data.fromDate).format('d MMM YYYY')}</td>
                                <td>{Moment(data.toDate).format('d MMM YYYY')}</td>
                                <td>{data.remarks}</td>
                                <td hidden={true}>{data.sl}</td>

                                <td className="text-center">
                                    <input
                                        type="submit"
                                        onClick={() => onDataDelete(data.sl, data.registerID)}
                                        className="btn btn-danger"
                                        value="Delete" />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    }

    return (
        <Layout>
            <Toast ref={primeToast} />
            <div className="card">
                <div className="card-header">
                    <div className="row">
                        <div className="col-md-6">
                            <select id="ddlEmployee" name="ddlEmployee" className="form-select"
                                onChange={onEmployeeSelect}
                                aria-label=".form-select-sm example">
                                <option value={-1}>{"Select Employee"}</option>
                                {employees.map((value, index) => <option key={index}
                                    value={value.registerID}>{value.employeeName}</option>)}
                            </select>
                        </div>

                        <div className="col-md-6" style={{ textAlign: 'right', fontSize: '.85rem' }}>
                            <b>Quarter:</b> {user.quarterName}/{new Date().getFullYear()}
                        </div>

                    </div>
                </div>
                <div className="card-body">
                    {employeeAssessment.length !== 0 ?
                        <EmpInfoCard empName={employeeAssessment[0].employeeName}
                            department={employeeAssessment[0].department}
                            designation={employeeAssessment[0].designation}
                            email={employeeAssessment[0].email} />
                        : (<div className="p-5"><h3>Employee Wise <b>Action Plan </b> </h3></div>)}
                    {isAssessmentLoading ? <ProgressSpinner style={{ width: 20, height: 20 }} /> : ""}
                    {employeeAssessment.length !== 0 ? <div className="row">
                        {employeeAssessment.map((value, index) => <div key={index} className="col-md-4">

                        </div>)}


                        <div className="card">
                            <br />
                            <div className="container">
                                <div className="row">
                                    <div className="col">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Development Activity"
                                            onChange={(e) => setActivity(e.target.value)}
                                            autoFocus="autoFocus"
                                            value={activity}
                                            name="activity"
                                        />
                                    </div>
                                    <div class="col">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Remarks"
                                            onChange={(e) => setRemarks(e.target.value)}
                                            autoFocus="autoFocus"
                                            value={remarks}
                                            name="remarks"
                                        />
                                    </div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <input
                                            type="date"
                                            className="form-control"
                                            placeholder="Development Activity"
                                            onChange={(e) => setFromDate(e.target.value)}
                                            autoFocus="autoFocus"
                                            value={fromdate}
                                            name="fromDate"
                                        />
                                    </div>
                                    <div class="col">
                                        <input
                                            type="date"
                                            className="form-control"
                                            placeholder="Development Activity"
                                            onChange={(e) => setToDate(e.target.value)}
                                            autoFocus="autoFocus"
                                            value={toDate}
                                            name="toDate"
                                        />
                                    </div>
                                </div>
                                <br />
                                <div className="row">
                                    <div class="col text-end">
                                        <input
                                            type="submit"
                                            onClick={onFormSave}
                                            className="btn btn-success"
                                            value="Save"
                                        />
                                    </div>
                                </div>
                            </div>

                            <br />

                            <Table tableData={tableData} />
                        </div>


                    </div> : <div></div>}

                    <br />

                    {/* <Table tableData={tableData} /> */}

                </div>
            </div>
        </Layout>
    )
}
export default EmployeeWiseActionPlan